import { z } from "zod";

export const reviewStatusSchema = z.enum(["IN_REVIEW", "ACCEPTED", "DECLINED"]);

export type ReviewStatus = z.infer<typeof reviewStatusSchema>;
